
import { FC, PropsWithChildren, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import StagesContext from '../../contexts/data/StagesContext';
import StageContext, { IStageContext } from '../../contexts/data/StageContext';


export interface IStageProviderProps {
}

export const StageProvider: FC<PropsWithChildren<IStageProviderProps>> = ({ children }) => {
    const stages = useContext(StagesContext);

    const stageId = Number(useParams()?.stageId);

    const stage  = useMemo(() => {
        if (!stageId) {
            return {
                data: stages.data && stages.data.length > 0 ? stages.data[0] : undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as IStageContext;
        }

        return {
            data: stages.data?.find(x => x.id === stageId),
            id: stageId,
            error: stages.error,
            loading: stages.loading,
            validating: stages.validating,
            refresh: async () => {
                const newData = await stages.refresh();

                return newData?.find(x => x.id === stageId);
            },
        } as IStageContext
    }, [stages, stageId]);

    return (

        <StageContext.Provider value={stage}>
            {children}
        </StageContext.Provider>
    );
}

export default StageProvider;
